import request from '@/utils/request'
// 表格列表
export function userskillstatisticst(data) {
  return request({
    url: '/sys/userskillstatistics/list',
    method: 'post',
    data
  })
}
// 表格下载
export function download(data) {
  return request({
    url: '/sys/userskillstatistics/download',
    method: 'post',
    data
  })
}